import { call, put, take, takeLatest } from 'redux-saga/effects'
import { replace } from 'redux-first-history'
import { SubmissionError } from 'redux-form'

import { errorHandler } from '@/core/helpers/errorHelpers'
import { hideCandidateProfileSaga } from '@/core/sagas/candidateProfile'

import * as profileCompletionModule from '../reducks/profileCompletion'
import * as profileModule from '../reducks/profile'
import * as profileApi from '../apiModules/profile'

function* fetchProfileImageSaga(action) {
  try {
    const image = yield call(profileApi.fetchProfileImage, action.payload.id)
    yield put(profileModule.fetchProfileImageSuccess(image.url))
  } catch (error) {}
}

function* fetchProfileSaga(action) {
  try {
    const profile = yield call(profileApi.fetchProfile, action.payload.id)
    yield put(profileModule.fetchProfileSuccess(profile))
  } catch (error) {}
}

function* updateProfileSaga(action) {
  try {
    const response = yield call(profileApi.updateProfile, action.payload.data, action.payload.id)
    yield put(profileModule.updateProfileSuccess(response))
    yield put(profileCompletionModule.fetchCompletion(action.payload.id))

    switch (action.type) {
      case profileModule.UPDATE_NEXT_JOB:
        yield put(profileModule.nextJobToggle(false))
        break

      case profileModule.UPDATE_ABOUT:
        yield put(profileModule.aboutToggle(false))
        break

      case profileModule.UPDATE_PERSONAL_INFORMATION:
        yield put(replace(`/candidate/${response.slug}`))
        break
    }

    yield call(action.meta.resolve)
  } catch (err) {
    if (err.response && err.response.status === 400) {
      const error = 'Error updating profile'
      yield call(action.meta.reject, new SubmissionError({ _error: error }))
      yield put(profileModule.updateProfileError(error))
    }
  }
}

function* updateProfileImageSaga(action) {
  const uploadChannel = yield call(profileApi.uploadFileChannel, action.payload.id, action.payload.data)

  while (true) {
    const { progressEvent, response = {} } = yield take(uploadChannel)

    if (progressEvent && progressEvent.lengthComputable) {
      yield put(profileModule.updateUploadProgress((progressEvent.loaded / progressEvent.total) * 100, true))
    }

    if (response.success) {
      yield put(profileModule.updateProfileImageSuccess(response.result.url))
      yield put(profileModule.updateUploadProgress(0, false))
      yield put(profileCompletionModule.fetchCompletion(action.payload.id))
    }
  }
}

function* hideProfileSaga({ meta }) {
  try {
    yield call(hideCandidateProfileSaga, meta.id, meta.data)
    yield put(profileModule.fetchProfile(meta.id))
    yield call(meta.resolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield call(meta.reject, new SubmissionError({ _error: error }))
  }
}

export default function* watchProfileSaga() {
  yield takeLatest(profileModule.FETCH, fetchProfileSaga)
  yield takeLatest(profileModule.FETCH_IMAGE, fetchProfileImageSaga)

  yield takeLatest(profileModule.UPDATE, updateProfileSaga)
  yield takeLatest(profileModule.UPDATE_PERSONAL_INFORMATION, updateProfileSaga)
  yield takeLatest(profileModule.UPDATE_SALARY, updateProfileSaga)
  yield takeLatest(profileModule.UPDATE_ABOUT, updateProfileSaga)
  yield takeLatest(profileModule.UPDATE_NEXT_JOB, updateProfileSaga)
  yield takeLatest(profileModule.HIDE_UPDATE_PROFILE_NOTICE, updateProfileSaga)
  yield takeLatest(profileModule.UPDATE_OVERALL_EXPERIENCE, updateProfileSaga)

  yield takeLatest(profileModule.UPDATE_IMAGE, updateProfileImageSaga)

  yield takeLatest(profileModule.HIDE_PROFILE, hideProfileSaga)
}
